import { GET_CHANNEL_POSTS } from '../../../../graphql/queries/channelPosts';
import type {
  GetChannelPostsQuery,
  GetChannelPostsQueryVariables,
} from '../../../../types/graphql-generated';
import { PostFeed } from './PostFeed';
import { usePaginatedPosts } from '../utils/usePaginatedPosts';

interface ChannelPostListProps {
  channelId: string;
}

// The published posts of a single channel, newest first, with pull-to-refresh
// and infinite scroll pagination. Uses cache-and-network so posts added
// elsewhere (e.g. just published) show up on revisit instead of a stale list.
export const ChannelPostList = ({ channelId }: ChannelPostListProps) => {
  const feed = usePaginatedPosts<GetChannelPostsQuery, GetChannelPostsQueryVariables>(
    GET_CHANNEL_POSTS,
    'channelPosts',
    { channelId },
    { fetchPolicy: 'cache-and-network' },
  );

  return <PostFeed {...feed} emptyMessage="Este canal aún no tiene publicaciones." />;
};
